module.exports = __webpack_public_path__ + "fonts/PTSans-Caption.f8b3f1b5.ttf";